(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.replace('no-js', 'js');

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const safeStorage = {
    get(key) {
      try {
        return window.localStorage.getItem(key);
      } catch {
        return null;
      }
    },
    set(key, value) {
      try {
        window.localStorage.setItem(key, value);
      } catch {
        return;
      }
    },
    sessionGet(key) {
      try {
        return window.sessionStorage.getItem(key);
      } catch {
        return null;
      }
    },
    sessionSet(key, value) {
      try {
        window.sessionStorage.setItem(key, value);
      } catch {
        return;
      }
    }
  };

  const preloader = document.querySelector('[data-preloader]');
  if (preloader) {
    const finishPreloader = () => {
      preloader.classList.add('is-finished');
      safeStorage.sessionSet('champion_intro_seen', 'true');
    };

    if (reducedMotion.matches || safeStorage.sessionGet('champion_intro_seen')) {
      finishPreloader();
    } else if (document.readyState === 'complete') {
      window.setTimeout(finishPreloader, 450);
    } else {
      window.addEventListener('load', () => window.setTimeout(finishPreloader, 450), { once: true });
      window.setTimeout(finishPreloader, 2200);
    }
  }

  const header = document.querySelector('[data-site-header]');
  const nav = document.querySelector('[data-site-nav]');
  const menuToggle = document.querySelector('[data-menu-toggle]');

  if (header) {
    let previousScroll = window.scrollY;
    let headerFrame = false;

    const updateHeader = () => {
      const currentScroll = window.scrollY;
      header.classList.toggle('is-scrolled', currentScroll > 24);
      header.classList.toggle('is-hidden', currentScroll > previousScroll && currentScroll > 160 && !nav?.classList.contains('is-open'));
      previousScroll = currentScroll;
      headerFrame = false;
    };

    window.addEventListener('scroll', () => {
      if (!headerFrame) {
        window.requestAnimationFrame(updateHeader);
        headerFrame = true;
      }
    }, { passive: true });
  }

  if (menuToggle && nav) {
    const compactNavigation = window.matchMedia('(max-width: 70rem)');
    let menuOpen = false;

    const getMenuFocusables = () => [
      ...nav.querySelectorAll('a[href], summary, button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      menuToggle
    ].filter((element) => !element.closest('[hidden]') && element.getClientRects().length > 0);

    const setMenuState = (open, restoreFocus = false) => {
      const compact = compactNavigation.matches;
      menuOpen = compact && open;
      nav.classList.toggle('is-open', menuOpen);
      if (menuOpen) header?.classList.remove('is-hidden');
      header?.classList.toggle('is-menu-open', menuOpen);
      menuToggle.setAttribute('aria-expanded', String(menuOpen));
      menuToggle.setAttribute('aria-label', menuOpen ? menuToggle.dataset.closeLabel : menuToggle.dataset.openLabel);
      nav.inert = compact && !menuOpen;

      if (compact && !menuOpen) {
        nav.setAttribute('aria-hidden', 'true');
      } else {
        nav.removeAttribute('aria-hidden');
      }

      document.body.style.overflow = menuOpen ? 'hidden' : '';

      if (menuOpen) {
        window.requestAnimationFrame(() => getMenuFocusables()[0]?.focus());
      } else if (restoreFocus) {
        menuToggle.focus();
      }
    };

    menuToggle.addEventListener('click', () => setMenuState(!menuOpen, menuOpen));

    nav.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        setMenuState(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (!menuOpen) {
        return;
      }

      if (event.key === 'Escape') {
        event.preventDefault();
        setMenuState(false, true);
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      const focusables = getMenuFocusables();
      const firstFocusable = focusables[0];
      const lastFocusable = focusables[focusables.length - 1];

      if (!focusables.includes(document.activeElement)) {
        event.preventDefault();
        firstFocusable?.focus();
      } else if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable?.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable?.focus();
      }
    });

    compactNavigation.addEventListener('change', () => setMenuState(false));
    setMenuState(false);
  }

  const localeRoot = document.querySelector('[data-localization-form]');
  const localeForm = localeRoot?.querySelector('form');
  const localeSelect = localeForm?.querySelector('[name="locale_code"]');

  if (localeForm && localeSelect) {
    localeSelect.addEventListener('change', () => {
      safeStorage.set('champion_locale', localeSelect.value);
      localeForm.submit();
    });

    const savedLocale = safeStorage.get('champion_locale');
    const currentLocale = document.documentElement.dataset.locale || '';
    const browserLocale = navigator.languages?.[0] || navigator.language || '';
    const shouldDetect = localeRoot.dataset.detectArabic === 'true';

    if (!savedLocale && shouldDetect && browserLocale.toLowerCase().startsWith('ar') && !currentLocale.toLowerCase().startsWith('ar')) {
      const arabicOption = Array.from(localeSelect.options).find((option) => option.value.toLowerCase().startsWith('ar'));
      if (arabicOption) {
        localeSelect.value = arabicOption.value;
        safeStorage.set('champion_locale', arabicOption.value);
        localeForm.submit();
      }
    }
  }

  const animatedElements = document.querySelectorAll('[data-animate]');
  if (animatedElements.length) {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      animatedElements.forEach((element) => element.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const delay = Number(entry.target.dataset.delay || 0);
            window.setTimeout(() => entry.target.classList.add('is-visible'), delay);
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

      animatedElements.forEach((element) => revealObserver.observe(element));
    }
  }

  document.querySelectorAll('[data-counter]').forEach((counter) => {
    const target = Number(counter.dataset.counter || 0);
    const suffix = counter.dataset.suffix || '';

    const runCounter = () => {
      if (reducedMotion.matches) {
        counter.textContent = `${target}${suffix}`;
        return;
      }

      const start = performance.now();
      const duration = 1100;

      const tick = (time) => {
        const progress = Math.min((time - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        counter.textContent = `${Math.round(target * eased)}${suffix}`;
        if (progress < 1) {
          window.requestAnimationFrame(tick);
        }
      };

      window.requestAnimationFrame(tick);
    };

    if ('IntersectionObserver' in window) {
      const counterObserver = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          runCounter();
          observer.disconnect();
        }
      }, { threshold: 0.5 });
      counterObserver.observe(counter);
    } else {
      runCounter();
    }
  });

  document.querySelectorAll('[data-technology]').forEach((section) => {
    const steps = Array.from(section.querySelectorAll('[data-tech-step]'));
    const scenes = Array.from(section.querySelectorAll('[data-tech-scene]'));
    const visual = section.querySelector('[data-tech-visual]');
    if (!steps.length || !scenes.length) {
      return;
    }

    const appleMobileBrowser = /iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const safariBrowser = appleMobileBrowser || (/Safari/i.test(navigator.userAgent) && !/Chrome|Chromium|CriOS|Edg|OPR|Android/i.test(navigator.userAgent));
    const supportsTransparentVideo = document.createElement('video').canPlayType('video/webm; codecs="vp9"');
    const compactTechnology = window.matchMedia('(max-width: 50rem)');
    // Safari can decode VP9 WebM but discards its alpha channel, so it gets the animated WebP instead.
    const useSafariAnimation = safariBrowser || !supportsTransparentVideo;

    // The visual is display:none below 50rem, so there is nothing to show and nothing worth downloading.
    const visualHidden = compactTechnology.matches;

    const loadTechnologyImage = (scene) => {
      if (visualHidden) {
        return;
      }
      const image = scene?.querySelector('[data-tech-safari-image]');
      if (!image || image.getAttribute('src') || !image.dataset.safariSrc) {
        return;
      }

      image.src = image.dataset.safariSrc;
    };

    const loadTechnologyVideo = (scene) => {
      if (!scene || visualHidden) {
        return;
      }
      const video = scene.querySelector('[data-tech-video]');
      if (!video || video.src || reducedMotion.matches) {
        return;
      }

      // The mp4 is opaque, so it is only ever a last resort if no transparent source exists.
      const source = video.dataset.alphaSrc || video.dataset.fallbackSrc;
      if (!source) {
        return;
      }

      video.src = source;
      video.load();
    };

    let activeIndex = -1;
    let techFrame = false;

    const activateTechnology = (index) => {
      const nextIndex = Math.min(Math.max(index, 0), steps.length - 1, scenes.length - 1);
      if (nextIndex === activeIndex) {
        return;
      }

      activeIndex = nextIndex;
      steps.forEach((step, stepIndex) => step.classList.toggle('is-active', stepIndex === activeIndex));
      scenes.forEach((scene, sceneIndex) => {
        const isActive = sceneIndex === activeIndex;
        const video = scene.querySelector('[data-tech-video]');
        scene.classList.toggle('is-active', isActive);
        scene.classList.toggle('uses-static-poster', reducedMotion.matches);
        scene.classList.toggle('uses-safari-animation', useSafariAnimation && !reducedMotion.matches);

        if (useSafariAnimation) {
          if (isActive && !reducedMotion.matches) {
            loadTechnologyImage(scene);
          }
          video?.pause();
          return;
        }

        if (!video) {
          return;
        }

        if (isActive && !reducedMotion.matches) {
          loadTechnologyVideo(scene);
          const playRequest = video.play();
          if (playRequest) {
            playRequest.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
      if (visual) {
        visual.dataset.techActive = String(activeIndex + 1);
      }
    };

    activateTechnology(0);
    if (reducedMotion.matches) {
      scenes.forEach((scene) => scene.querySelector('[data-tech-video]')?.pause());
      return;
    }

    if (compactTechnology.matches) {
      let cycleTimer = false;
      const sceneCount = Math.min(steps.length, scenes.length);
      const stopCycle = () => {
        if (cycleTimer) {
          window.clearInterval(cycleTimer);
          cycleTimer = false;
        }
      };
      const startCycle = () => {
        stopCycle();
        cycleTimer = window.setInterval(() => {
          activateTechnology((activeIndex + 1) % sceneCount);
        }, 2800);
      };

      if ('IntersectionObserver' in window) {
        const technologyObserver = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            const activeScene = scenes[activeIndex];
            if (useSafariAnimation) {
              loadTechnologyImage(activeScene);
            } else {
              loadTechnologyVideo(activeScene);
              const activeVideo = activeScene?.querySelector('[data-tech-video]');
              const playRequest = activeVideo?.play();
              if (playRequest) {
                playRequest.catch(() => {});
              }
            }
            startCycle();
          } else {
            stopCycle();
            scenes.forEach((scene) => scene.querySelector('[data-tech-video]')?.pause());
          }
        }, { threshold: 0.2 });
        technologyObserver.observe(section);
      } else {
        startCycle();
      }
      return;
    }

    const updateTechnology = () => {
      const bounds = section.getBoundingClientRect();
      const distance = Math.max(section.offsetHeight - window.innerHeight, 1);
      const progress = Math.min(Math.max(-bounds.top / distance, 0), 1);
      section.style.setProperty('--tech-progress', progress.toFixed(3));
      activateTechnology(Math.floor(progress * steps.length));
      techFrame = false;
    };

    window.addEventListener('scroll', () => {
      if (!techFrame) {
        window.requestAnimationFrame(updateTechnology);
        techFrame = true;
      }
    }, { passive: true });
    updateTechnology();
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const productRoot = select.closest('[data-product-root]');
      const price = productRoot?.querySelector('[data-product-price]');
      const button = productRoot?.querySelector('[data-add-to-cart]');
      const galleryItems = productRoot?.querySelectorAll('[data-product-media-id]') || [];

      if (price && option.dataset.price) {
        price.textContent = option.dataset.price;
      }

      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        const label = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
        const labelElement = button.querySelector('span');
        if (labelElement) {
          labelElement.textContent = label;
        }
      }

      if (option.dataset.mediaId) {
        galleryItems.forEach((item) => {
          item.hidden = item.dataset.productMediaId !== option.dataset.mediaId;
        });
      }
    });
  });

  document.querySelectorAll('[data-product-recommendations]').forEach((recommendationsRoot) => {
    const loadRecommendations = async () => {
      if (recommendationsRoot.dataset.loaded === 'true') {
        return;
      }

      recommendationsRoot.dataset.loaded = 'true';
      recommendationsRoot.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(recommendationsRoot.dataset.url);
        if (!response.ok) {
          throw new Error(`Recommendations request failed with ${response.status}`);
        }

        const responseText = await response.text();
        const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const recommendations = responseDocument.querySelector('[data-product-recommendations]');

        if (recommendations?.innerHTML.trim()) {
          recommendationsRoot.innerHTML = recommendations.innerHTML;
        }
      } catch {
        recommendationsRoot.dataset.loaded = 'false';
      } finally {
        recommendationsRoot.removeAttribute('aria-busy');
      }
    };

    if ('IntersectionObserver' in window) {
      const recommendationsObserver = new IntersectionObserver((entries, observer) => {
        if (entries[0].isIntersecting) {
          observer.disconnect();
          loadRecommendations();
        }
      }, { rootMargin: '400px 0px' });
      recommendationsObserver.observe(recommendationsRoot);
    } else {
      loadRecommendations();
    }
  });

  document.querySelectorAll('[data-collection-filters]').forEach((collectionRoot) => {
    const facetsPanel = collectionRoot.querySelector('[data-facets-panel]');
    const facetsToggle = collectionRoot.querySelector('[data-facets-toggle]');
    const facetsCloseControls = collectionRoot.querySelectorAll('[data-facets-close]');

    if (!facetsPanel || !facetsToggle) {
      return;
    }

    const compactFacets = window.matchMedia('(max-width: 50rem)');
    let facetsOpen = false;

    const getFacetFocusables = () => [
      ...facetsPanel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])')
    ].filter((element) => element.getClientRects().length > 0);

    const setFacetsState = (open, restoreFocus = false) => {
      const compact = compactFacets.matches;
      facetsOpen = compact && open;
      facetsPanel.classList.toggle('is-open', facetsOpen);
      facetsToggle.setAttribute('aria-expanded', String(facetsOpen));
      facetsPanel.inert = compact && !facetsOpen;
      document.body.classList.toggle('facets-open', facetsOpen);

      if (compact && !facetsOpen) {
        facetsPanel.setAttribute('aria-hidden', 'true');
      } else {
        facetsPanel.removeAttribute('aria-hidden');
      }

      if (facetsOpen) {
        window.requestAnimationFrame(() => getFacetFocusables()[0]?.focus());
      } else if (restoreFocus) {
        facetsToggle.focus();
      }
    };

    facetsToggle.addEventListener('click', () => setFacetsState(!facetsOpen, facetsOpen));
    facetsCloseControls.forEach((control) => {
      control.addEventListener('click', () => setFacetsState(false, true));
    });

    facetsPanel.addEventListener('keydown', (event) => {
      if (!facetsOpen || event.key !== 'Tab') {
        return;
      }

      const focusables = getFacetFocusables();
      const firstFocusable = focusables[0];
      const lastFocusable = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable?.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable?.focus();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && facetsOpen) {
        setFacetsState(false, true);
      }
    });

    compactFacets.addEventListener('change', () => setFacetsState(false));
    setFacetsState(false);
  });

  document.querySelectorAll('[data-specification-open]').forEach((trigger) => {
    const dialog = document.getElementById(trigger.dataset.specificationOpen);
    if (!dialog) {
      return;
    }

    trigger.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.dataset.restoreCustomCursor = String(document.documentElement.classList.contains('has-custom-cursor'));
        document.documentElement.classList.remove('has-custom-cursor');
        document.documentElement.classList.add('specification-dialog-open');
        dialog.showModal();
      } else if (trigger.dataset.fallbackUrl) {
        window.location.assign(trigger.dataset.fallbackUrl);
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('specification-dialog-open');
      if (dialog.dataset.restoreCustomCursor === 'true') {
        document.documentElement.classList.add('has-custom-cursor');
      }
      delete dialog.dataset.restoreCustomCursor;
      trigger.focus();
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach((control) => {
    control.addEventListener('change', () => control.form?.submit());
  });

  if (!reducedMotion.matches && window.matchMedia('(pointer: fine)').matches) {
    const cursorDot = document.createElement('span');
    const cursorRing = document.createElement('span');
    cursorDot.className = 'performance-cursor performance-cursor--dot';
    cursorRing.className = 'performance-cursor performance-cursor--ring';
    cursorDot.setAttribute('aria-hidden', 'true');
    cursorRing.setAttribute('aria-hidden', 'true');
    document.body.append(cursorDot, cursorRing);
    document.documentElement.classList.add('has-custom-cursor');

    let cursorX = -48;
    let cursorY = -48;
    let ringX = -48;
    let ringY = -48;
    let cursorFrame = false;

    const renderCursor = () => {
      ringX += (cursorX - ringX) * 0.16;
      ringY += (cursorY - ringY) * 0.16;
      cursorDot.style.setProperty('--cursor-x', `${cursorX}px`);
      cursorDot.style.setProperty('--cursor-y', `${cursorY}px`);
      cursorRing.style.setProperty('--cursor-x', `${ringX}px`);
      cursorRing.style.setProperty('--cursor-y', `${ringY}px`);

      if (Math.abs(cursorX - ringX) > 0.1 || Math.abs(cursorY - ringY) > 0.1) {
        window.requestAnimationFrame(renderCursor);
      } else {
        cursorFrame = false;
      }
    };

    window.addEventListener('pointermove', (event) => {
      cursorX = event.clientX;
      cursorY = event.clientY;
      cursorDot.classList.add('is-visible');
      cursorRing.classList.add('is-visible');
      const cursorTarget = event.target.closest?.('a, button, summary, select, [role="button"], .product-card, .hero-showcase, .collection-visual');
      cursorRing.classList.toggle('is-active', Boolean(cursorTarget));
      if (!cursorFrame) {
        cursorFrame = true;
        window.requestAnimationFrame(renderCursor);
      }
    }, { passive: true });

    document.documentElement.addEventListener('mouseleave', () => {
      cursorDot.classList.remove('is-visible');
      cursorRing.classList.remove('is-visible');
    });

    document.documentElement.addEventListener('mouseenter', () => {
      cursorDot.classList.add('is-visible');
      cursorRing.classList.add('is-visible');
    });

    document.querySelectorAll('.hero-showcase, .collection-visual').forEach((visual) => {
      visual.addEventListener('pointermove', (event) => {
        const bounds = visual.getBoundingClientRect();
        const relativeX = Math.min(Math.max((event.clientX - bounds.left) / bounds.width, 0), 1);
        const relativeY = Math.min(Math.max((event.clientY - bounds.top) / bounds.height, 0), 1);
        visual.style.setProperty('--spot-x', `${(relativeX * 100).toFixed(1)}%`);
        visual.style.setProperty('--spot-y', `${(relativeY * 100).toFixed(1)}%`);
        visual.style.setProperty('--cursor-rx', `${((0.5 - relativeY) * 4).toFixed(2)}deg`);
        visual.style.setProperty('--cursor-ry', `${((relativeX - 0.5) * 5).toFixed(2)}deg`);
      }, { passive: true });
      visual.addEventListener('pointerleave', () => {
        visual.style.setProperty('--spot-x', '50%');
        visual.style.setProperty('--spot-y', '48%');
        visual.style.setProperty('--cursor-rx', '0deg');
        visual.style.setProperty('--cursor-ry', '0deg');
      });
    });

    document.querySelectorAll('.button').forEach((button) => {
      button.addEventListener('pointermove', (event) => {
        const bounds = button.getBoundingClientRect();
        const x = (event.clientX - bounds.left - bounds.width / 2) * 0.08;
        const y = (event.clientY - bounds.top - bounds.height / 2) * 0.08;
        button.style.transform = `translate(${x}px, ${y}px)`;
      });
      button.addEventListener('pointerleave', () => {
        button.style.transform = '';
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
